import axios from '~/util/axios'

export default {
  getIds (code) {
    return axios.get(`/api/v1/analytics?activation_code=${code}`)
  },
  getInternalId () {
    return axios.get('/api/v1/analytics_internal')
  }
}
